var map = {
	"./assets/1.svg": 11,
	"./assets/10.svg": 12,
	"./assets/2.svg": 13,
	"./assets/3.svg": 14,
	"./assets/4.svg": 15,
	"./assets/5.svg": 16,
	"./assets/5things-logo-white.svg": 17,
	"./assets/6.svg": 18,
	"./assets/7.svg": 19,
	"./assets/8.svg": 20,
	"./assets/9.svg": 21,
	"./assets/CHECK-thick-teal.svg": 22,
	"./assets/CHECK-thick-white.svg": 23,
	"./assets/X-thick-white.svg": 24,
	"./assets/_twitter.svg": 25,
	"./assets/cnn-core-logo.svg": 26,
	"./assets/cnn-logo-badge.svg": 27,
	"./assets/cnn-politics-logo.svg": 28,
	"./assets/facebook.svg": 29,
	"./assets/instagram.svg": 30,
	"./assets/twitter.svg": 31
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;


//////////////////
// WEBPACK FOOTER
// ./src/media ^\.\/.*\.*
// module id = 37
// module chunks = 0